<i18n>
{
  "fr": {},
  "en": {}
}
</i18n>

<template>
  <div class="card is-item" @mouseover="$emit('hover', item)">
    <header class="card-header">
      <p class="card-header-title">
        <b-button
          icon-left="external-link"
          size="is-small"
          @click="$emit('open', item)"
        ></b-button>
        {{ item.title }}
      </p>
    </header>
    <div class="card-content">
      <div
        class="item-text"
        v-html="item.text"
        style="height: 8em; overflow: hidden"
      ></div>
    </div>

    <footer class="card-footer">
      <action-tag-list :tags="item.tags"></action-tag-list>
    </footer>

    <footer class="card-footer">
      <div class="columns is-multiline">
        <div class="column" v-for="(file, index) in item.files" :key="index">
          <a href="#" @click="$emit('on-click-file', file)">
            <b-icon icon="paperclip" />
            {{ file.name | truncate(20) }}
          </a>
        </div>
      </div>
    </footer>
    <footer class="card-footer">
      {{ item.entity.name }}
    </footer>
  </div>
</template>

<script>
export default {
  name: 'CardAction',
  components: {
    'action-tag-list': () => import('@/components/transition/ActionTagList.vue')
  },
  emits: ['hover', 'open', 'on-click-file'],
  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.card.is-item {
  background-color: rgb(255, 255, 255, 1) !important;
  font-size: 80%;
  margin: 5px 5px 20px 5px;
  padding: 1px;
}

.card.is-item:hover {
  border: 1px solid black;
}

.card-content .item-text {
  background: -webkit-linear-gradient(90deg, rgb(255, 255, 255), rgb(0, 0, 0));
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: rgba(82, 74, 72, 0.5);
}
</style>
